import React, { useEffect, useState } from "react";
import LOGO_MTN from "./../assets/images/momo.png";
import "./../assets/css/hamburgers.css";

// icons
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyIcon from "@mui/icons-material/Key";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

const NavbarEntite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [userProfil, setUserProfil] = useState("");

  const deconnecteAdmin = () => {
    localStorage.removeItem("momo4scoohclient");
    navigate("/login");
  };

  useEffect(() => {
    const token = localStorage.getItem('momo4scoohclient')

    if (token) {
      const decodedToken = jwtDecode(token)
      setUserProfil(decodedToken)
    }
  }, [])
  

  return (
    <div className="fixed w-full h-28 pb-3 bg-[#29668b] z-50">
      <div className="relative w-11/12 max-w-screen-2xl h-full mx-auto flex justify-between items-center">
        <div className="flex items-center gap-x-2 cursor-pointer">
          <img src={LOGO_MTN} alt="logo mtn" className="w-11 rounded-lg" />
          <span className="text-gl text-white font-bold leading-6">MoMo Business</span>
        </div>
        <div className="main-menu flex items-center gap-x-3 lg:gap-x-3 xl:gap-x-5 flex">
          <NavLink to="/entites">
            <button className="text-white text-sm flex items-center gap-x-1">
              <DashboardCustomizeIcon />
              <span>Entités</span>
            </button>
          </NavLink>
          {/* {userProfil.profil === "ROLE_AdminClient" ? <NavLink to="/utilisateurs">
            <button className="text-white text-sm flex items-center gap-x-1">
              <PeopleIcon />
              <span>Utilisateurs</span>
            </button>
          </NavLink> : null} */}
          <NavLink to="/identifiants">
            <button className="text-white text-sm flex items-center gap-x-1">
              <KeyIcon />
              <span>Identifiants</span>
            </button>
          </NavLink>
          <button
            className="bg-red-500 text-white px-3 py-2 rounded-md text-sm font-medium flex items-center gap-x-2"
            onClick={deconnecteAdmin}
          >
            <LogoutIcon />
            <span className="">Déconnexion</span>
          </button>
        </div>
        {/* <button
          style={{ marginTop: "10px", padding: 0 }}
          className={
            visible
              ? "hamburger hamburger--collapse burger-btn is-active"
              : "hamburger hamburger--collapse burger-btn"
          }
          type="button"
          onClick={(e) => setVisible(true)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button> */}
      </div>

      <div className="z-10 absolute bottom-0 left-0 right-0 bg-gray-mtn w-full">
        <svg
          height="19px"
          viewBox="0 0 1366 19.18"
          preserveAspectRatio="none"
          className="w-full hidden sm:block bg-jaune-mtn"
        >
          <path
            d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
            fill="#f2F2f2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 500 40"
          preserveAspectRatio="xMidYMin meet"
          className="w-full block sm:hidden bg-gray-mtn"
        >
          <path d="M0,0 Q250,80 500,0 Z" fill="#ffcc02"></path>
        </svg>
      </div>

      {/* <Sidebar visible={visible} onHide={() => setVisible(false)}>
        <div className=" mt-10 main-menu flex flex-col items-start gap-y-8 lg:hidden">
          <NavLink to="/dashboard">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <DashboardIcon />
              <span>Tableau de bord</span>
            </button>
          </NavLink>
          <NavLink to="/niveau-etude">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <BusinessCenterIcon />
              <span>Niveaux d'étude</span>
            </button>
          </NavLink>
          <NavLink to="/tarifs">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <AccountBalanceWalletRoundedIcon />
              <span>Tarifs</span>
            </button>
          </NavLink>
          <NavLink to="/paiement">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <PaidIcon />
              <span>Paiement</span>
            </button>
          </NavLink>
          <NavLink to="/eleves">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <SchoolRoundedIcon />
              <span>Elèves</span>
            </button>
          </NavLink>
          <NavLink to="/utilisateurs">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <PeopleIcon />
              <span>Utilisateurs</span>
            </button>
          </NavLink>
          <NavLink to="/identifiants">
            <button className="text-black text-base font-bold flex items-center gap-x-1">
              <KeyIcon />
              <span>Identifiants</span>
            </button>
          </NavLink>
          <button
            className="bg-red-500 text-white w-full px-4 py-2 rounded-md text-sm font-medium flex items-center gap-x-2"
            onClick={deconnecteAdmin}
          >
            <LogoutIcon />
            <span>Déconnexion</span>
          </button>
        </div>
      </Sidebar> */}
    </div>
  );
};

export default NavbarEntite;
